/*= ========================================================================================
  File Name: moduleCalendarState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== */

export default {
  customers: [],
  customer: null,
  customersRaw: null,
  vPage: 0,
  vLimit: 0,
  vTotalCount: 0,
  vTotalPages: 0,
  customerFilters: [],
  walletHistory: [],
  walletHistoryRaw: null,
}

// 0 - employee
// 1 - branch
// 2 - organisation admin
// 3 - we
